module.exports = __webpack_public_path__ + "img/snow-mode-on.b06005fd.svg";